"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import { AndYouData } from "../../../sanity/lib/queries/getAndYouData";
import { FooterData } from "../../../sanity/lib/queries/getFooterData";
import { AndYou } from "./andYou";
import { Footer } from "./footer";
import useIsMobile from "../../hooks/useIsMobile";

export default function ({
    footerData,
    andYou,
}: {
    footerData?: FooterData;
    andYou?: AndYouData["andYou"];
}) {
    const bgColors = andYou?.andYouColors || ["#ffffff"];
    const ref = useRef<HTMLDivElement>(null);
    const [isIntersecting, setIntersecting] = useState(false);
    const [isOnTop, setIsOnTop] = useState(false);
    const [asset, setAsset] = useState(andYou?.andYouLettering?.[0]?.image);
    const [idx, setIdx] = useState(1);
    const observer = useRef<IntersectionObserver>(null);
    const observerHero = useRef<IntersectionObserver>(null);
    const { isMobile } = useIsMobile();

    const updateBackgroundColor = useCallback(
        (index: number) => {
            if (isIntersecting) {
                const r = document.querySelector<HTMLElement>(":root");

                r?.style.setProperty("--bg-color", bgColors[index]);
                setAsset(andYou?.andYouLettering?.[index]?.image);
                setIdx(index);
            }
        },
        [isIntersecting],
    );

    useEffect(() => {
        updateBackgroundColor(idx);
    }, [isIntersecting]);

    useEffect(() => {
        if (isOnTop) {
            const r = document.querySelector<HTMLElement>(":root");

            r?.style.setProperty("--bg-color", "#ffffff");
        }
    }, [isOnTop]);

    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0.1,
        };

        observer.current = new IntersectionObserver(
            ([entry]) => setIntersecting(entry.isIntersecting),
            observerOptions,
        );
    }, []);

    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0.1,
        };

        observerHero.current = new IntersectionObserver(
            ([entry]) => setIsOnTop(entry.isIntersecting),
            observerOptions,
        );
    }, []);

    useEffect(() => {
        if (ref.current) {
            observer.current?.observe(ref.current);
        }
        return () => observer.current?.disconnect();
    }, []);

    useEffect(() => {
        const heroSection = document.querySelector(".intersection-hero") as HTMLElement;

        if (heroSection) {
            observerHero.current?.observe(heroSection);
        }
        return () => observerHero.current?.disconnect();
    }, [isMobile]);

    return (
        <div className="footer-wrapper" ref={ref}>
            {andYou && andYou && (
                <AndYou
                    setIdx={setIdx}
                    idx={idx}
                    data={andYou}
                    updateBackgroundColor={updateBackgroundColor}
                    asset={asset}
                />
            )}
            {footerData && <Footer data={footerData} />}
        </div>
    );
}
